import { Component, OnInit, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';

import { isIPv6 } from 'is-ip';
import Rollbar from 'rollbar';
import { filter } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { ROLLBAR_SERVICE } from './app.module';
import { IpService } from './services/ip.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  static ip4Address: string = '';
  static ip6Address: string = '';

  private titleService = inject(Title);
  private meta = inject(Meta);
  private router = inject(Router);
  private ip = inject(IpService);
  private rollbar = inject<Rollbar>(ROLLBAR_SERVICE);
  private ip4AddressCloudFunctions: string = '';
  private ip4AddressIpify: string = '';

  ngOnInit() {
    this.titleService.setTitle(`${environment.projectTitle} Voter Portal`);
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.syncRobots(event.urlAfterRedirects);
      });
    this.syncRobots(this.router.url);
    this.ip.getIPAddressFromCloudFunctions().subscribe((ipAddress: string) => {
      if (!environment.production) {
        console.log(`IP from Cloud Functions: ${ipAddress}`);
      }
      if (ipAddress) {
        if (isIPv6(ipAddress)) {
          AppComponent.ip6Address = ipAddress;
        } else {
          this.ip4AddressCloudFunctions = ipAddress;
          // We always use the Cloud Functions IP address if available.
          AppComponent.ip4Address = ipAddress;
        }
        this.compareIps();
      }
    });
    // TODO: Remove ipify.org method if we decide IPv6 addresses alone are sufficient.
    this.ip.getIPAddressFromIpify().subscribe((ipAddress: string) => {
      if (!environment.production) {
        console.log(`IP from ipify.org: ${ipAddress}`);
      }
      if (ipAddress) {
        // ipify.org returns IPv4 addresses only.
        this.ip4AddressIpify = ipAddress;
        // We use the ipify.org IP address only if the Cloud Functions IP address is not set.
        if (!AppComponent.ip4Address) {
          AppComponent.ip4Address = ipAddress;
        }
        this.compareIps();
      }
    });
  }

  private syncRobots(url: string) {
    const path = url.split('?')[0].replace(/\/+$/, '') || '/';
    const indexable = path === '/' || path === '/login';
    this.meta.updateTag({ name: 'robots', content: indexable ? 'index, follow' : 'noindex, nofollow' });
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', 'https://voters.terpeca.com/');
  }

  private compareIps() {
    if (this.ip4AddressCloudFunctions && this.ip4AddressIpify && this.ip4AddressCloudFunctions !== this.ip4AddressIpify) {
      this.rollbar.error(
        `IPV4 addresses differ - Cloud Functions: ${this.ip4AddressCloudFunctions} ipify.org: ${this.ip4AddressIpify}`);
    }
  }
}
